/** @jsx jsx */
import React from 'react';
import { jsx } from '@emotion/core';
import { useTheme } from '../../theme';
import { topLevelElementCss } from '.';
export const Code = React.forwardRef((props, ref) => {
    const theme = useTheme();
    return (jsx("code", Object.assign({}, props, { ref: ref, css: [
            topLevelElementCss,
            {
                display: 'block',
                color: theme.colors.code.text,
                caretColor: theme.colors.paragraph.text,
                borderWidth: '1px',
                borderStyle: 'solid',
                borderColor: theme.colors.code.border,
                backgroundColor: theme.colors.code.background,
                wordBreak: 'break-all',
            },
        ] })));
});
Code.displayName = 'Code';
export default React.memo(Code);
//# sourceMappingURL=Code.js.map